var GoogleMap = (function (window, document, $, undefined) {

    var EXT = {};

    /**
     * @type {services}
     */
    var services = new function () {

        /**
         *
         * @param selector
         * @returns {boolean}
         */
        this.has = function (selector) {
            return !!(selector);
        };

        /**
         *
         * @param selector
         * @returns {*|HTMLElement}
         */
        this.get = function (selector) {
            return $(selector);
        };

        /**
         *
         * @param url
         */
        this.substituteHttpWithCurrentProtocol = function (url) {
            return url.replace('http:', location.protocol);
        };

    };


    /**
     *
     * @type {map}
     */
    var googleMaps = new function () {

        this.config = {
            center: {
                lat: 50.8,
                lng: 12.8
            },
            zoom: 10,
            mapTypeId: (typeof google !== 'undefined') ? google.maps.MapTypeId.ROADMAP : 'roadmap',
            disableDefaultUI: 1,
            disableDoubleClickZoom: 1,
            zoomControl: 1,
            scrollwheel: 0,
            draggable: 1,
            icon: window.location.origin + '/typo3conf/ext/xm_templates_dhm/Resources/Public/images/pin_black.png'
        };

        this.mapSelector = '#dhmd-google-maps';
        this.infoboxSelector = '#dhmd-google-maps-infobox';

        this.map = null;
        this.markers = [];
        this.infoWindows = [];
        this.mapStyle = [{
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [{"color": "#444444"}]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{"color": "#F9F9F9"}]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"lightness": 45}]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{"color": "#d7808e"}, {"visibility": "on"}]
        }];


        /**
         *
         * @returns {Array}
         */
        this.getMap = function () {
            return this.map;
        };

        /**
         *
         * @returns {Array}
         */
        this.getMarkers = function () {
            return this.markers;
        };


        /**
         * Initializer
         *
         * @returns {map}
         */
        this.init = function () {
            var self = this;

            if (typeof google !== 'undefined' && google !== null) {
                self.map = new google.maps.Map(document.getElementById('dhmd-google-maps'), {
                    center: new google.maps.LatLng(
                        self.config.center.lat, self.config.center.lng
                    ),
                    zoom: parseInt(self.config.zoom),
                    mapTypeId: self.config.mapTypeId,
                    disableDefaultUI: self.config.disableDefaultUI,
                    disableDoubleClickZoom: self.config.disableDoubleClickZoom,
                    zoomControl: self.config.zoomControl,
                    scrollwheel: self.config.scrollwheel,
                    draggable: self.config.draggable,
                    streetViewControl: false,
                    styles: self.mapStyle
                });

                if (googleMapsMarker !== undefined) {
                    googleMapsMarker.forEach(function (item) {
                        self.addMarker(self.map, item);
                    });
                }
            }

            return self.map;
        };

        /**
         *
         * @param map
         * @param item
         * @returns {marker}
         */
        this.addMarker = function (map, item) {
            var self = this;

            var marker = new google.maps.Marker({
                position: {lat: parseFloat(item.lat), lng: parseFloat(item.lng)},
                title: item.title,
                clickable: true,
                map: self.map,
                animation: google.maps.Animation.DROP,
                icon: services.substituteHttpWithCurrentProtocol(self.config.icon)
            });

            var index = self.markers.length;
            self.markers.push(marker);

            var contentString = '<div id="dhmd-google-maps-infobox">'+
                '<h3>' + item.title + '</h3>'+
                '<p>' + item.content + '</p>' +
                '<div><a class="more" href="' + item.link + '">Details</a></div>' +
                '</div>';

            self.markers[index].infobox = new google.maps.InfoWindow({
                content: contentString,
                maxWidth: 200
            });

            google.maps.event.addListener(marker, 'click', (function(marker, index) {
                return function() {
                    (self.activeInfobox != null) ? self.activeInfobox.infobox.close() : null ;
                    self.activeInfobox = self.markers[index];
                    self.activeInfobox.infobox.open(self.map, this);
                    self.map.panTo(self.activeInfobox.position);
                }
            })(marker, index));

            return marker;
        };

    };




    /**
     * initialize
     */
    EXT.initialize = function () {
        googleMaps.init();
    };


    return EXT;

})(window, document, jQuery);


$(document).ready(function () {

});